export const QUARTERS = [
  { id: 1, label: "Q1 (JAN-MAR)" },
  { id: 2, label: "Q2 (APR-JUN)" },
  { id: 3, label: "Q3 (JUL-SEP)" },
  { id: 4, label: "Q4 (OCT-DEC)" },
];
